// вызвать flutter

async function callFlutter(action: string) {
  const args = {
    action: 'call_flutter',
    data: [],
  };

  const res = await (window as any).flutter_inappwebview.callHandler(
    'js_handler_on_flutter',
    JSON.stringify(args)
  );
  console.log('ответ от flutter', res);
}

async function flutterTouchId() {
  console.log('run ---> flutterTouchId');
  const args = {
    action: 'auth_by_touch_id',
    args: {},
  };

  const res = await (window as any).flutter_inappwebview.callHandler(
    'js_handler_on_flutter',
    JSON.stringify(args)
  );
  // console.log('ответ от flutter', res)
  return res;
}

async function saveIinFlutter(iin: string) {
  const action = 'save_iin';
  const args = {
    action,
    args: {
      iin,
    },
  };

  const res = await (window as any).flutter_inappwebview.callHandler(
    'js_handler_on_flutter',
    JSON.stringify(args)
  );
  // console.log('ответ от flutter', res)
  return res;
}

async function saveTouchIdInfo(user_iin: string, password: string) {
  // alert(user_iin)
  const action = 'save_touch_info';
  const args = {
    action,
    args: {
      iin: user_iin,
      pass: password,
      touchEnable: 'true', /// признак при первой авторизации
    },
  };

  const res = await (window as any).flutter_inappwebview.callHandler(
    'js_handler_on_flutter',
    JSON.stringify(args)
  );
  // console.log('ответ от flutter', res)
  return res;
}

/// позвонить
async function makeCall(phone: string) {
  const action = 'make_call';
  const args = {
    action,
    args: {
      phone,
    },
  };

  const res = await (window as any).flutter_inappwebview.callHandler(
    'js_handler_on_flutter',
    JSON.stringify(args)
  );
  // console.log('ответ от flutter', res)
  return res;
}

/// позвонить
async function openWhatsap(phone_s: string, text_s: string) {
  const action = 'open_whatsapp';
  const args = {
    action,
    args: {
      phone: phone_s,
      text: text_s,
    },
  };

  const res = await (window as any).flutter_inappwebview.callHandler(
    'js_handler_on_flutter',
    JSON.stringify(args)
  );
  // console.log('ответ от flutter', res)
  return res;
}

async function openBrowser(url: string) {
  const action = 'open_browser';
  const args = {
    action,
    args: {
      url,
    },
  };

  const res = await (window as any).flutter_inappwebview.callHandler(
    'js_handler_on_flutter',
    JSON.stringify(args)
  );
  // console.log('ответ от flutter', res)
  return res;
}

async function openKaspiPay(url_t: string) {
  const action = 'open_kaspi';
  const args = {
    action,
    args: {
      url: url_t,
    },
  };

  const res = await (window as any).flutter_inappwebview.callHandler(
    'js_handler_on_flutter',
    JSON.stringify(args)
  );
  console.log('ответ от flutter', res);
  return res;
}

/// позвонить
async function resetTouchInfo() {
  const action = 'reset_touch_info';
  const args = {
    action,
    args: {},
  };

  const res = await (window as any).flutter_inappwebview.callHandler(
    'js_handler_on_flutter',
    JSON.stringify(args)
  );
  // console.log('ответ от flutter', res)
  return res;
}

async function getInfoFlutter() {
  const args = {
    action: 'get_info',
    args: {},
  };

  const res = await (window as any).flutter_inappwebview.callHandler(
    'js_handler_on_flutter',
    JSON.stringify(args)
  );
  // console.log('ответ от flutter', res)
  return res;
}

async function makePhoto() {
  const args = {
    action: 'do_photo',
    args: {},
  };

  try {
    const res = await (window as any).flutter_inappwebview.callHandler(
      'js_handler_on_flutter',
      JSON.stringify(args)
    );
    return res;
  } catch (e: any) {
    console.error(e.toString());
    const err = e.toString();
    if (String(err).search('callHandler') !== -1) {
      return {
        code: false,
        msg: 'Не доступно в веб весрии',
        data: {},
      };
    }
    return {
      code: false,
      msg: e.toString(),
      data: {},
    };
  }
}

async function openJpay(htmlInBase: string) {
  const args = {
    action: 'open_jusan_pay',
    args: {
      html: htmlInBase,
    },
  };

  const res = await (window as any).flutter_inappwebview.callHandler(
    'js_handler_on_flutter',
    JSON.stringify(args)
  );
  // console.log('ответ от flutter', res)
  return res;
}

export {
  openKaspiPay,
  callFlutter,
  flutterTouchId,
  saveIinFlutter,
  getInfoFlutter,
  saveTouchIdInfo,
  openJpay,
  makeCall,
  resetTouchInfo,
  makePhoto,
  openWhatsap,
  openBrowser,
};
